import { Component, ViewEncapsulation, Injector, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveysServiceProxy, CreateOrEditSurveyDto, CreateOrEditQuestionDto, CreateOrEditSurveyContactDto, RegistrationsServiceProxy, UserServiceProxy, UserViewDto, EventsServiceProxy, BannerImageInput, EventListDto, CreateOrEditOptionDto, CopySurveyInput } from '@shared/service-proxies/service-proxies';
import { QuestionType, SurveyCategory } from '@shared/AppEnums';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { AppConsts } from '@shared/AppConsts';
import { IAjaxResponse } from 'abp-ng2-module/src/abpHttpInterceptor';
import { TokenService } from 'abp-ng2-module/src/auth/token.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { options } from 'toastr';

@Component({
    templateUrl: './create-or-edit-survey-modal.component.html',
    selector: 'createOrEditSurveyModal',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class CreateOrEditSurveyModalComponent extends AppComponentBase implements OnInit {

    @ViewChild('createOrEditModal') modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    questionType = QuestionType;
    surveCategory = SurveyCategory;

    survey: CreateOrEditSurveyDto = new CreateOrEditSurveyDto();

    events = [];
    surveyEvents = [];
    selectedEvent: EventListDto;
    selectedBaseEvent: EventListDto;
    surveyParentQuestions = [];
    subQuestionTypes = [];

    public maxProfilPictureBytesUserFriendlyValue = 5;
    private _uploaderOptions: FileUploaderOptions = {};
    private _$eventPictureResize: JQuery;
    private _$jcropApi: any;

    public uploaderBanner: FileUploader;
    public temporaryBannerUrl: string;
    private temporaryBannerFileName: string;
    private _uploaderBannerOptions: FileUploaderOptions = {};

    showSurveyForm = false;
    selectBaseSurvey : string = 'false';
    active = false;
    saving = false;
    showButton = true;
    countName = 0;

    constructor(
        injector: Injector,
        private _router: Router,
        private _tokenService: TokenService,
        private _eventsService: EventsServiceProxy,
        private _surveysServiceProxy: SurveysServiceProxy,
    ) {
        super(injector);
    }

    ngOnInit(): void {

    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }


    public show(surveyId?: number): void {

        this.initialize();
        this.initBannerUploader();

        this.subQuestionTypes = this.questionType.Types.filter(x => x == 0 || x == 2 || x == 6);

        this.active = true;

        surveyId = surveyId ? surveyId : 0;

        this._surveysServiceProxy.getSurveyForEdit(surveyId, undefined).subscribe(result => {

            if (result.survey) {
                this.survey = result.survey;
                this.survey.questions = this.survey.questions.filter(x => !x.parentId);
                this.selectedEvent = result.survey.event;
                this.survey.event = undefined;
            }

            if (!this.survey.bannerImageInput)
                this.survey.bannerImageInput = new BannerImageInput();

            this.modal.show();
        });
    }

    onShown(): void {
        this.modal.show();

    }

    close(): void {
        this.active = false;
        this.showSurveyForm = false;
        this.selectBaseSurvey = 'false';
        this.selectedBaseEvent = undefined;
        this.modal.hide();
    }

    initialize() {

        this.survey.questions = [];
        this.showSurveyForm = false;
        this.selectBaseSurvey = 'false';
        this.selectedBaseEvent = undefined;
    }

    save() {

        this.survey.eventId = this.selectedEvent.id;

        if (this.temporaryBannerFileName) {
            this.survey.bannerImageInput = new BannerImageInput()
            this.survey.bannerImageInput.fileName = this.temporaryBannerFileName;
        }
        else {
            this.survey.bannerImageId = this.survey.bannerImageId;
            this.survey.bannerImageInput = undefined;
        }

        // Preserve real (positive) ids so the backend can update existing questions/options/sub-questions
        // in place instead of deleting and reinserting them. Newly added items carry ids <= 0
        // (see addNewQuestion/addOption/addSubquestion) and are normalized to 0 to be inserted as new.
        // Sending id=0 for everything is what caused #7004 (HTTP 500 when editing answered surveys).
        this.survey.questions.forEach(x => {
            x.id = x.id > 0 ? x.id : 0;
            x.specify = !!x.specifyLabelText;
            x.surveyId = this.survey.id ? this.survey.id : 0;

            if (x.scaleRating > 0) {
                this.setRatingOptions(x);
            }

            if (x.options) {
                x.options.forEach(o => {
                    o.id = o.id > 0 ? o.id : 0;
                    o.specify = !!o.specifyLabelText;
                });
            }
            if (x.subQuestions) {
                x.subQuestions.forEach(s => {
                    s.id = s.id > 0 ? s.id : 0;
                    s.specify = !!s.specifyLabelText;
                    s.surveyId = this.survey.id ? this.survey.id : 0;
                    s.parentId = x.id;
                    s.number = s.number ? s.number : null;

                    if (s.scaleRating > 0) {
                        this.setRatingOptions(s);
                    }

                    if (s.options) {
                        s.options.forEach(o => {
                            o.id = o.id > 0 ? o.id : 0;
                            o.specify = !!o.specifyLabelText;
                        });
                    }

                });
            }
        })

        this._surveysServiceProxy.createOrEdit(this.survey)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    copySurvey() {

        if (this.selectedBaseEvent) {
            let input = new CopySurveyInput();
            input.eventBaseId = this.selectedBaseEvent.id;
            input.eventId = 0;

            this._surveysServiceProxy.copySurvey(input)
                .subscribe((data: CreateOrEditSurveyDto) => {
                    this.survey = data
                    this.survey.eventId = undefined;
                    this.survey.event = undefined;
                    this.showSurveyForm = true;
                    this.notify.info(this.l('SavedSuccessfully'));
                    this.show(data.id);
                });
        }
        else {

            this.showSurveyForm = true;
        }
    }


    setRatingOptions(question: CreateOrEditQuestionDto) {
        // Keep the ids of the options already persisted (matched by answer text) so that editing a
        // rating question reuses the existing rows instead of dropping them. Recreating these options
        // would delete rows referenced by answers and break the edit (#7004).
        let existingIdsByText: { [text: string]: number } = {};
        (question.options || []).forEach(o => {
            if (o.id > 0 && o.answerText != null) {
                existingIdsByText[o.answerText] = o.id;
            }
        });

        question.options = [];
        for (let i = 0; i < question.scaleRating; i++) {
            let option = new CreateOrEditOptionDto();
            if (question.type == this.questionType.MultipleChoice) {
                if (question.scaleRating == 2) { //Checkbox value: "sim ou não"
                    option.answerText = question.options.length == 1 ? "Não" : "Sim";
                }
                else {
                    option.answerText = (i + 1).toString();
                }
            }
            else {
                option.answerText = (i + 1).toString();
            }
            if (existingIdsByText[option.answerText]) {
                option.id = existingIdsByText[option.answerText];
            }
            question.options.push(option);
        }

        question.options = question.options.sort((a, b) => +a.answerText - +b.answerText);
    };


    initBannerUploader(): void {

        this.temporaryBannerUrl = '';
        this.temporaryBannerFileName = '';

        this.uploaderBanner = new FileUploader({ url: AppConsts.remoteServiceBaseUrl + '/Event/UploadProgrammingImage' });
        this._uploaderBannerOptions.autoUpload = true;
        this._uploaderBannerOptions.authToken = 'Bearer ' + this._tokenService.getToken();
        this._uploaderBannerOptions.removeAfterUpload = true;
        this.uploaderBanner.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploaderBanner.onSuccessItem = (item, response, status) => {
            const resp = <IAjaxResponse>JSON.parse(response);
            if (resp.success && resp.result.fileName) {
                this.temporaryBannerFileName = resp.result.fileName;
                this.temporaryBannerUrl = AppConsts.remoteServiceBaseUrl + '/Temp/Downloads/' + resp.result.fileName + '?v=' + new Date().valueOf();

            } else {
                let message = resp.error ? resp.error.message : resp.result.message;
                this.message.error(message);
            }
        };
        this.uploaderBanner.setOptions(this._uploaderBannerOptions);
    }

    filterEvents(event): void {
        this._eventsService.getEventsForSelect(event.query, 0, undefined, false, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
            this.events = result.items;
        });
    }

    filterSurveyEvents(event): void {
        this._eventsService.getEventsForSelect(event.query, 0, undefined, true, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
            this.surveyEvents = result.items;
        });
    }

    upadateExpirationDate(value: string) {
        this.survey.expirationDate = value ? moment(value, 'L') : null;
    }

    addNewQuestion(type: number, text: string) {
        let question = new CreateOrEditQuestionDto();
        question.id = this.countName--;
        question.text = text;
        question.type = type;
        question.options = [];
        question.subQuestions = [];
        this.survey.questions.push(question);
        this.reloadOrderQuestions();
    }

    deleteQuestion(i: number) {
        this.survey.questions.splice(i, 1);
        this.reloadOrderQuestions();
    }

    addOption(i: number) {
        let option = new CreateOrEditOptionDto();
        option.id = this.countName--;

        if (this.survey.questions[i].type == this.questionType.ContactInformation) {
            option.contactInfo = new CreateOrEditSurveyContactDto();
            option.contactInfo.id = this.countName--;
        }

        this.survey.questions[i].options.push(option);
    }

    addSubquestion(i: number, type?: number) {
        let subquestion = new CreateOrEditQuestionDto();
        subquestion.id = this.countName--;
        subquestion.type = type;
        subquestion.options = [];
        subquestion.subQuestions = [];

        this.survey.questions[i].subQuestions.push(subquestion);
    }

    deleteOption(i: number, j: number) {
        this.survey.questions[i].options.splice(j, 1);
    }

    deleteSubQuestion(i: number, j: number) {
        this.survey.questions[i].subQuestions.splice(j, 1);
    }

    reloadOrderQuestions(): void {

        let number = 1;
        for (let i = 0; i < this.survey.questions.length; i++) {

            if (!this.survey.questions[i].parentId)
                this.survey.questions[i].number = (number++).toString();
        }

    }

    getTypeQuestionClass(type: number): string {
        switch (type) {
            case QuestionType.MultipleChoice: {
                return 'fa fa-check-square'
            }
            case QuestionType.BoxSelection: {
                return 'fa fa-check-square-o'
            }
            case QuestionType.Text: {
                return 'fa fa-file-text-o'
            }
            case QuestionType.Group: {
                return 'fa fa-object-group'
            }
            case QuestionType.Comment: {
                return 'fa fa-comment-o'
            }
            case QuestionType.ContactInformation: {
                return 'fa fa-phone'
            }
            case QuestionType.StarRating: {
                return 'fa fa-star-o'
            }
            default:
                return 'fa fa-plus-square-o'
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/event/surveys/modals/create-or-edit-survey-modal.component.ts